import React, { useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import * as actions from '../store/actions'
import { AppContext } from '../../../global'
import './PartnerSummary.css'
import { RequestState } from '../../types'
import Panel from '../../../components/panels/Panel'
import PanelBody from '../../../components/panels/PanelBody'

type Props = {
  partnerId: string
}

function PartnerSummary(props: Props) {
  const { state, execute } = useContext(AppContext)
  const partnerId = props.partnerId
  const dashboardState = state.dashboard
  const partnerSummaryState = dashboardState.partnerSummary

  const { t } = useTranslation(['dashboard'])

  useEffect(
    () => {
      execute(actions.loadPartnerSummary(partnerId))
    },
    // eslint-disable-next-line
    [partnerId]
  )

  function renderSummaryLoading() {
    return (
      <div className="summary-message">
        <i className="fas fa-spinner fa-spin font-size-xl"></i>
        <br />
      </div>
    )
  }

  function renderSummaryError() {
    return ( 
      <div className="summary-message">{t('reseller_summary.error')}</div>
    )
  }

  function renderSummary() {
    return (
      <>
        <div className="summary-item">
          <div className="summary-title">
            <strong>{t('reseller_summary.total_subscriptions')}</strong>
          </div>
          <div id="total-subscriptions" className="summary-stat">
            {partnerSummaryState.totalSubscriptions}
          </div>
        </div>
        <div className="summary-item">
          <div className="summary-title">
            <strong>{t('reseller_summary.total_trials')}</strong>
          </div>
          <div id="trial-subscription" className="summary-stat">
            {partnerSummaryState.trialSubscriptions}
          </div>
        </div>
        <div className="summary-item">
          <div>
            <strong>{t('reseller_summary.added_this_month')}</strong>
          </div>
          <div id="subscriptions-added-month" className="summary-stat">
            {partnerSummaryState.subscriptionsAddedMonth}
          </div>
        </div>
        <div className="summary-item">
          <div className="summary-title">
            <strong>{t('reseller_summary.deactivated_this_month')}</strong>
          </div>
          <div id="subscriptions-deactivated-month" className="summary-stat">
            {partnerSummaryState.subscriptionsDeactivatedMonth}
          </div>
        </div>
      </>
    )
  }

  return (
    <Panel
      id="partner-summary"
      className={'panel-dark' + (partnerSummaryState.requestState === RequestState.Loaded ? ' loaded' : '')}>
      <PanelBody>
        {partnerSummaryState.requestState === RequestState.Loading && renderSummaryLoading()}
        {partnerSummaryState.requestState === RequestState.Error && renderSummaryError()}
        {partnerSummaryState.requestState === RequestState.Loaded && renderSummary()}
      </PanelBody>
    </Panel>
  )
}

export default PartnerSummary
